import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import TransfertArticleType from "../../_App/Types/Entites/TransfertArticle/TransfertArticleType";
import {
  SelectedOrganisationId,
  SelectedOrganisations,
  selectUser,
  selectUserId,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import {
  CurrentPage,
  Listdemande_transfer_cree,
  TotalPages,
  confirmTransfertApi,
  getlesDemandeTransfertCreeApi,
  retourTransfertApi,
} from "../../_App/Redux/Slices/transferArticle/transferArticleSlice";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import BonTransfert from "./files/BonTransfert";
import Accordion from "react-bootstrap/Accordion";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { setListItems } from "../../_App/Redux/Slices/AppParametrages/parametrageMenus/parametrageMenuSlice";
import { findClientByBarcode } from "../../_App/Redux/Slices/client/clientSlice";
import {
  findArticleByBarCode,
  findArticleRefParentApi,
} from "../../_App/Redux/Slices/article/articleSlice";
import Swal from "sweetalert2";
import { Button, Spinner } from "react-bootstrap";
import ArticleListReference from "../../_Layouts/RightBar/RightBar/cart/ArticleListReference";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { calculTotal } from "../../_App/Helpers/helpers";
import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";

export default function ListTransfertCree({ ShowModal, setShowModal }: any) {
  const { t } = useTranslation();
  const selectedOrganisationId = useAppSelector(SelectedOrganisationId);
  const list_organisation = useAppSelector(SelectedOrganisations);
  const [etat, setetat] = useState("approve");
  const [list, setlist] = useState<TransfertArticleType[]>([]);
  const user = useAppSelector(selectUserId);
  const societeid = useAppSelector(societeId);
  const userinfo = useAppSelector(selectUser);
  const [ListReference, setListReference] = useState<any[]>();
  const [ShowModalListReference, setShowModalListReference] = useState(false);

  const listdemande_transfer_cree = useAppSelector(Listdemande_transfer_cree);
  const dispatch = useAppDispatch();
  const [showbon, setshowbon] = useState(false);
  const [dataBon, setDatataBon] = useState();
  const [expandedIndex, setExpandedIndex] = useState<any>(null);
  const [scanIndex, setScanIndex] = useState<any>(null);
  const [scanValue, setscanValue] = useState<any>("");
  const [loadingsearch, setloadingsearch] = useState(false);
  const [indexItem, setIndexItem] = useState(1);
  const currentpage = useAppSelector(CurrentPage);
  const totalPages = useAppSelector(TotalPages);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [TypeInput, setTypeInput] = useState("codeBarre");
  useEffect(() => {
    if (selectedOrganisationId !== null &&societeid){
       dispatch(
        getlesDemandeTransfertCreeApi({
          societe_id: societeid,
          organisation_id: selectedOrganisationId,
          etat,
          indexItem,
        }),
      );
    }else{
      setlist([])
    }
     
  }, [userinfo,societeid, selectedOrganisationId, etat, indexItem]);

  useEffect(() => {
    if (listdemande_transfer_cree) {
      setlist(listdemande_transfer_cree);
    }
  }, [listdemande_transfer_cree]);

  const showConfrim = (index: any) => {
    const findOneScan = list[index].lignes.find((el) => el.QuantitReception);
    return findOneScan;
  };
  const confirmer = async (idTransfert: string, index: number) => {
    const data = {
      _id: idTransfert,
      user: user,
      societe_id: societeid,
      note: list[index].note,
      lignes: list[index].lignes,
    };
    if (showConfrim(index)) {
      await Confirmfunction(data);
    } else {
      Swal.fire({
        title: "Voulez-vous vraiment confirmer la réception même tout Qte 0 ? ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await Confirmfunction(data);
        }
      });
    }
  };
  const confirmDirect = async (idTransfert: string, index: number) => {
    const listligne = list[index].lignes.map((item) => {
      return { ...item, QuantitReception: item.Quantiteenvoyee };
    });
    const data = {
      _id: idTransfert,
      user: user,
      societe_id: societeid,
      note: list[index].note,
      lignes: listligne,
    };
    await Confirmfunction(data);
  };
  const Confirmfunction = async (data: any) => {
    Swal.fire({
      title: "Voulez vous vraiment confirmer la reception? ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await dispatch(confirmTransfertApi(data));
        if (response?.payload.status) {
          setDatataBon(response.payload.data);
          setshowbon(true);
          if (userinfo?.role_id?.libelle) {
            dispatch(
              getlesDemandeTransfertCreeApi({
                societe_id: societeid,
                organisation_id: "null",
                etat,
                indexItem,
              }),
            );
          } else {
            if (selectedOrganisationId)
              dispatch(
                getlesDemandeTransfertCreeApi({
                  societe_id: societeid,
                  organisation_id: selectedOrganisationId,
                  etat,
                  indexItem,
                }),
              );
          }
        }
      }
    });
  };
  const retour = async (idTransfert: string, index: number) => {
    const data = { _id: idTransfert, user: user, note: list[index].note };
    const response = await dispatch(retourTransfertApi(data));
    if (response?.payload.success) {
      ToastSuccess(response?.payload.message);
      setShowModal(false);
    }
  };
  const ajoutnote = async (index: number, value: string) => {
    const copie = list.map((item, i) =>
      i === index ? { ...item, note: value } : item,
    );
    setlist(copie);
  };
  const closenote = async (index: number) => {
    const updatedList = list.map((item, i) =>
      i === index ? { ...item, note: undefined } : item,
    );
    setlist(updatedList);
  };
  const voirbon = (item: any) => {
    setDatataBon(item);
    setshowbon(true);
  };

  const lastKeyPressTime = useRef<number>(0);

  const handelScan = (cleanedValue: any) => {
    setscanValue(cleanedValue);
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;
    // Si le temps entre deux entrées est court, c'est probablement un scan
    const isScannerInput = timeDiff < 50;
    //117065alert(isScannerInput)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(
      async () => {
        if (cleanedValue !== "" || isScannerInput) {
          await handleInputChange(cleanedValue);
        }
      },
      isScannerInput ? 100 : 2000,
    );
  };

  const handleInputChange = async (inputValue: any) => {
    setloadingsearch(true);

    if (TypeInput === "codeBarre") {
      await scanReception(inputValue);
    } else {
      const resultReference = await dispatch(
        findArticleRefParentApi({ ref: inputValue, societe_id: societeid }),
      );

      // const resultBon = await dispatch(findBonByBarcode(inputValue));
      if (resultReference.payload) {
        const list = resultReference?.payload?.map((e: any) => {
          return { article: e };
        });
        setListReference(list);
        setShowModalListReference(true);
      } else {
        ToastWarning(t("Ce code n'est associé à aucun article "));
        setscanValue("");
      }
    }

    setloadingsearch(false);
  };

  const scanReception = async (value: any) => {
    if (scanIndex === null || scanIndex === undefined) {
      console.error("Aucun scanIndex défini");
      return;
    }

    const findTransfert = list[scanIndex];
    if (!findTransfert) {
      console.error("Aucun transfert trouvé pour cet index");
      return;
    }

    const copie = [...list];
    const findArticleIndex = findTransfert.lignes.findIndex((item) =>
      item.article_id.code_a_barre.includes(value),
    );

    if (findArticleIndex !== -1) {
      const updatedArticle = {
        ...findTransfert.lignes[findArticleIndex],
        QuantitReception:
          (findTransfert.lignes[findArticleIndex].QuantitReception || 0) + 1,
      };

      copie[scanIndex] = {
        ...findTransfert,
        lignes: [...findTransfert.lignes],
      };

      const newLignes = [...findTransfert.lignes];
      newLignes.splice(findArticleIndex, 1);
      // 🟢 L’ajouter en première ligne
      newLignes.unshift(updatedArticle);

      copie[scanIndex] = {
        ...findTransfert,
        lignes: newLignes,
      };
      setlist(copie);
    } else {
      const findArticle = await dispatch(
        findArticleByBarCode({ inputValue: value, societe: societeid }),
      );
      if (findArticle.payload) {
        const ArticleToAdd = {
          article_id: findArticle.payload,
          stock: null,
          Quantite: 0,
          Quantiteenvoyee: 0,
          QuantitReception: 1,
        };

        copie[scanIndex] = {
          ...findTransfert,
          lignes: [ArticleToAdd, ...findTransfert.lignes],
        };
        setlist(copie);
      }
    }

    setscanValue("");
  };

  const ClickMinus = async (index: any, articleId: any) => {
    if (scanIndex === null || scanIndex === undefined) {
      console.error("Aucun scanIndex défini");
      return;
    }

    const findTransfert = list[index];
    if (!findTransfert) {
      console.error("Aucun transfert trouvé pour cet index");
      return;
    }

    const copie = [...list];
    const findArticleIndex = findTransfert.lignes.findIndex(
      (item) => item.article_id._id === articleId,
    );

    if (findArticleIndex !== -1) {
      const updatedArticle = {
        ...findTransfert.lignes[findArticleIndex],
        QuantitReception:
          (findTransfert.lignes[findArticleIndex].QuantitReception || 0) - 1,
      };

      // Mise à jour de la liste
      copie[scanIndex] = {
        ...findTransfert,
        lignes: [...findTransfert.lignes],
      };

      copie[scanIndex].lignes[findArticleIndex] = updatedArticle;

      // Mise à jour de l'état
      setlist(copie);
    }

    setscanValue("");
  };
  const addArticle = async (ar: any) => {
    if (scanIndex === null || scanIndex === undefined) {
      console.error("Aucun scanIndex défini");
      return;
    }

    const findTransfert = list[scanIndex];
    if (!findTransfert) {
      console.error("Aucun transfert trouvé pour cet index");
      return;
    }

    const copie = [...list];
    const findArticleIndex = findTransfert.lignes.findIndex(
      (item) => item.article_id._id.includes(ar?.article?._id), // Utilisation de `includes` au lieu de `find`
    );

    if (findArticleIndex !== -1) {
      const updatedArticle = {
        ...findTransfert.lignes[findArticleIndex],
        QuantitReception:
          (findTransfert.lignes[findArticleIndex].QuantitReception || 0) + 1,
      };

      // Mise à jour de la liste
      copie[scanIndex] = {
        ...findTransfert,
        lignes: [...findTransfert.lignes],
      };

      copie[scanIndex].lignes[findArticleIndex] = updatedArticle;

      // Mise à jour de l'état
      setlist(copie);
    } else {
      const ArticleToAdd = {
        article_id: ar.article,
        stock: null,
        Quantite: 0,
        Quantiteenvoyee: 0,
        QuantitReception: 1,
      };

      copie[scanIndex] = {
        ...findTransfert,
        lignes: [...findTransfert.lignes, ArticleToAdd],
      };
      setlist(copie);
    }

    setscanValue("");
  };

  const findlignenonidentique = (index: any, ligneindex: any) => {
    const findTransfert = list[index];
    const findArticle = findTransfert.lignes[ligneindex];

    if (findArticle) {
      if (
        findArticle &&
        findArticle &&
        findArticle.Quantiteenvoyee === findArticle.QuantitReception
      ) {
        return true;
      }
      return false;
    }
    return false;
  };
  const toggleBody = (index: any) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div>
      <div className="row layout-spacing">
        <div className="col-lg-12    bg-white">
          <div className="inv--product-table-section ">
            <div className="row mt-5">
              <div className="col-6">
                <h3 className="c-primary">
                  {" "}
                  {t("Réception de la distribution")}{" "}
                </h3>
              </div>
              <div className="col-1 ">
                <span>Etat :</span>
              </div>
              <div className=" col-4 ">
                <select
                  className="form-control"
                  onChange={(e) => setetat(e.target.value)}
                >
                  {" "}
                  <option value="approve">{t("reçu non confirmé ")}</option>
                  <option value="confirme"> {t("confirmé")}</option>
                  <option value="encours">{t("en cours de demande")}</option>
                  <option value="nonapprove">
                    {t("non approuvé par source")}
                  </option>
                </select>
              </div>
            </div>

            {list && list.length > 0 && (
              <div className="row">
                <div className="col-1">{t("N° BT  ")} </div>
                <div className="col-1">{t("Organisation  ")} </div>
                <div className="col-1">{t("Depots ")} </div>
                <div className="col-1">{t("Date ")} </div>
                <div className="col-2">{t("Agent de livraison ")} </div>
              </div>
            )}

            <Accordion
              activeKey={
                expandedIndex !== null ? expandedIndex.toString() : null
              }
            >
              {list &&
                list.map((item: any, index: number) => (
                  <Accordion.Item eventKey={index.toString()} key={index}>
                    <Accordion.Header
                      onClick={(e) => {
                        e.stopPropagation(); // Empêche Bootstrap d'ouvrir l'accordion automatiquement
                        e.preventDefault(); // Empêche tout comportement par défaut
                      }}
                      className="row"
                    >
                      {item?.NumBontransfert ? (
                        <div className="col-1">
                          <span>{item?.NumBontransfert}</span>
                        </div>
                      ) : (
                        <div className="col-1"></div>
                      )}
                      <div className="col-1">
                        {item?.organisation_transfer === "null"
                          ? "Societe"
                          : item?.organisation_transfer?.nom}{" "}
                      </div>
                      <div className="col-1">{item.depots_id?.libelle}</div>
                      {etat === "encours" && (
                        <div className="col-2">
                          {item?.demander?.date.split("T")[0]}
                        </div>
                      )}

                      {etat === "approve" && (
                        <>
                          <div className="col-1">
                            {item?.accepter_transfer?.date?.split("T")[0]}
                          </div>
                          <div className="col-2">
                            {(item?.agentLivraison?.nom || "") +
                              " " +
                              (item?.agentLivraison?.prenom || "")}
                          </div>
                          {item.note !== undefined ? (
                            <div className="col-2">
                              <textarea
                                value={item.note}
                                onChange={(e) =>
                                  ajoutnote(index, e.target.value)
                                }
                              />
                              <i
                                onClick={() => closenote(index)}
                                className="far fa-window-close"
                              ></i>
                            </div>
                          ) : (
                            <button
                              className="btn btn-primary-app col-1"
                              onClick={() => ajoutnote(index, "")}
                            >
                              {t("Ajouter Note")}
                            </button>
                          )}

                          <button
                            className="btn btn-primary-app col-1"
                            onClick={() => confirmDirect(item._id, index)}
                          >
                            {t("Confirmer")}
                          </button>

                          <button
                            className="btn btn-primary-app col-1"
                            onClick={() => retour(item._id, index)}
                          >
                            {t("retour")} <i className="fas fa-undo-alt"></i>
                          </button>

                          {scanIndex !== index && (
                            <button
                              className="btn btn-primary-app "
                              onClick={() => {
                                setExpandedIndex(index);
                                setScanIndex(index);
                              }}
                            >
                              <i className="fas fa-barcode"></i>{" "}
                            </button>
                          )}

                          {scanIndex === index && (
                            <>
                              <i
                                className="fas fa-times"
                                onClick={() => {
                                  setExpandedIndex(null);
                                  setScanIndex(null);
                                }}
                              ></i>
                            </>
                          )}
                          {
                            <div
                              className="col-1"
                              title={t("Bon de reception (Brouillon)")}
                            >
                              <button
                                className="btn btn-primary-app "
                                onClick={() => {
                                  setDatataBon(item);
                                  setshowbon(true);
                                }}
                              >
                                <i className="fas fa-file-powerpoint"></i>{" "}
                                {t("B.R")}
                              </button>
                            </div>
                          }
                        </>
                      )}
                      {etat === "confirmé" && (
                        <>
                          <div className="col-1">
                            {item?.approver_reception?.date?.split("T")[0]}
                          </div>
                          <div className="col-2">
                            {(item?.agentLivraison?.nom || "") +
                              " " +
                              (item?.agentLivraison?.prenom || "")}
                          </div>
                          <div className="col-3">
                            <span
                              className=" btn-primary-app pointer"
                              onClick={() => {
                                setDatataBon(item);
                                setshowbon(true);
                              }}
                            >
                              <i className="fas fa-file-powerpoint"></i>{" "}
                              {t("Bon de reception")}
                            </span>
                          </div>
                        </>
                      )}
                      <div className="col-1">
                        <button
                          onClick={() => toggleBody(index)}
                          className="btn btn-link c-primary"
                        >
                          {expandedIndex === index ? "▲" : "▼"}
                        </button>
                      </div>
                    </Accordion.Header>
                    {expandedIndex === index && (
                      <Accordion.Body>
                        {scanIndex === index && (
                          <div className="row mb-3">
                            <div className="col-12">
                              <div
                                className="search-bar"
                                style={{ position: "relative" }}
                              >
                                <input
                                  type="text"
                                  className={
                                    "form-control search-form-control ml-lg-auto"
                                  }
                                  autoFocus={scanIndex === index}
                                  onChange={(e) => {
                                    // Nettoyer la valeur : éliminer les retours à la ligne et les espaces inutiles
                                    const cleaned = e.target.value
                                      .replace(/\n/g, "")
                                      .trim();

                                    handelScan(cleaned);
                                  }}
                                  value={scanIndex === index ? scanValue : ""}
                                  placeholder={t(
                                    "Enter code a barre ou bien ref ",
                                  )}
                                  id="code_input"
                                  style={{
                                    height: "40px",
                                    paddingRight: "2.5rem",
                                  }}
                                />

                                {loadingsearch ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Spinner
                                      animation="border"
                                      role="status"
                                      size="sm"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </Spinner>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {TypeInput === "codeBarre" ? (
                                      <button
                                        className="btn  btn-primary-app pointer"
                                        onClick={() => setTypeInput("ref")}
                                        style={{
                                          position: "absolute",
                                          right: "-10px",
                                          top: "-19px",
                                        }}
                                      >
                                        CB
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-primary-app pointer"
                                        onClick={() =>
                                          setTypeInput("codeBarre")
                                        }
                                        style={{
                                          position: "absolute",
                                          right: "-10px",
                                          top: "-19px",
                                        }}
                                      >
                                        REF
                                      </button>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="row mb-2 bg-primary-app ">
                          <div className="col-1"></div>
                          <div className=" fs-17 text-center col-3">
                            {t("Article")}
                          </div>

                          {etat === "encours" && (
                            <div className=" fs-17 text-center col-3">
                              {t("Quantite demandé")}
                            </div>
                          )}

                          {(etat === "approve" || etat === "confirme") && (
                            <>
                              <div className=" fs-17 text-center col-2">
                                {t("Quantite demandé ")}{" "}
                                {calculTotal(item.lignes, "Quantite")}
                              </div>
                              <div className=" fs-17 text-center col-2">
                                {t("Quantite apprové ")}{" "}
                                {calculTotal(item.lignes, "Quantiteenvoyee")}
                              </div>
                              <div className="fs-17  text-center col-2">
                                {t("Quantite Reception ")}{" "}
                                {calculTotal(item.lignes, "QuantitReception")}
                              </div>
                            </>
                          )}

                          {etat === "nonapprove" && (
                            <>
                              <div className="fs-17 col-3">
                                {t("Quantite demandé ")}{" "}
                                {calculTotal(item.lignes, "Quantite")}
                              </div>
                            </>
                          )}
                        </div>
                        {item.lignes.map((l: any, i: number) => (
                          <>
                            <div
                              className="row"
                              style={{
                                padding: "10px",
                                background: findlignenonidentique(index, i)
                                  ? ""
                                  : "#e5adad",
                              }}
                            >
                              <div className=" user-profile col-1">
                                {l.article_id?.image &&
                                l.article_id?.image !== null &&
                                l.article_id?.image?.length !== 0 ? (
                                  <Zoom>
                                    <img
                                      alt="image"
                                      src={
                                        process.env.REACT_APP_API_PUBLIC_URL +
                                        "article/" +
                                        l.article_id?.image
                                      }
                                      width="100"
                                    />
                                  </Zoom>
                                ) : (
                                  <img
                                    src="assets/assets/img/no-image.jpg"
                                    className="card-img-top"
                                    alt="..."
                                    style={{ width: "40px" }}
                                  />
                                )}
                              </div>
                              <div className="text-center fs-17 col-3">
                                {l.article_id?.titre?.fr}
                              </div>

                              {etat === "encours" && (
                                <div className="col-3 fs-17  text-center">
                                  {l.Quantite}
                                </div>
                              )}
                              {(etat === "approve" || etat === "confirme") && (
                                <>
                                  <div className=" fs-17 col-2   text-center">
                                    {l.Quantite}
                                  </div>
                                  <div className="col-2 fs-17  text-center">
                                    {l.Quantiteenvoyee || l.Quantite}
                                  </div>
                                  <div className="col-2 fs-17  text-center">
                                    {l.QuantitReception > 0 && (
                                      <i
                                        onClick={() =>
                                          ClickMinus(index, l?.article_id?._id)
                                        }
                                        className="fas fa-minus-circle"
                                      ></i>
                                    )}{" "}
                                    {l.QuantitReception || 0}
                                  </div>
                                </>
                              )}

                              {etat === "nonapprove" && (
                                <>
                                  <div className="col-3 fs-17  text-center">
                                    {l.Quantite}
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="mb-2"></div>
                          </>
                        ))}
                        {etat === "approve" && showConfrim(index) && (
                          <div className="d-flex justify-content-end mb-3">
                            <button
                              className="btn btn-primary-app"
                              onClick={() => confirmer(item._id, index)}
                            >
                              {t("confirmer")}
                            </button>
                          </div>
                        )}
                      </Accordion.Body>
                    )}
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
        </div>
      </div>
      {showbon && (
        <BonTransfert
          societeid={societeid}
          datainfo={dataBon}
          type="reception"
          t={t}
          setshowbon={setshowbon}
          ShowBon={showbon}
        />
      )}
      <ArticleListReference
        t={t}
        ShowModal={ShowModalListReference}
        setShowModal={setShowModalListReference}
        selectAricle={addArticle}
        list={ListReference}
        reference={scanValue}
      />
      <div className="row layout-spacing">
        <PaginationLayout
          index={indexItem}
          nbrpage={currentpage}
          totalpages={totalPages}
          setindex={setIndexItem}
        />
      </div>
    </div>
  );
}
